import React, { useState, useEffect, useCallback, useContext } from 'react';
import Proveedor from './Proveedor';
import { AuthContext } from '../contexts/AuthContext';

interface Provider 
{
  id: number;
  name: string;
  api_key: string;
  valid_ips: string;
}

const Proveedores: React.FC = () => 
{
  const { token } = useContext(AuthContext);
  const [providers, setProviders] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [selectedProvider, setSelectedProvider] = useState<Provider | null>(null);

  //-----------------------------------------------------------

  const fetchProviders = useCallback(async () =>
  {
    setLoading(true);
    setError(null);

    try 
    {
      const api_url = process.env.REACT_APP_API_BASE_URL || '';
      const response = await fetch(`${api_url}web/get_providers`, {
        method: 'GET',
        headers: {
          'X-AUTH-TOKEN': token || ''}});

      if (response.ok) 
      {
        const data = await response.json();
        setProviders(data);
      } 
      else 
      {
        throw new Error('Error al cargar proveedores.');
      }
    } 
    catch (error) 
    {
      const errorMsg = error instanceof Error ? error.message : 'Error desconocido';
      setError(errorMsg);
    } 
    finally 
    {
      setLoading(false);
    }
  }, [token]);

  //-----------------------------------------------------------

  useEffect(() => 
  {
    fetchProviders();
  }, [fetchProviders]);

  //-----------------------------------------------------------

  const handleCreateClick = () => 
  {
    setSelectedProvider({
        id: -1, // Para indicar que es un nuevo proveedor
        name: '',
        api_key: '',
        valid_ips: ''}); // Crear un proveedor vacío para la creación
  };
  
  //-----------------------------------------------------------

  const handleEditClick = (provider: Provider) => 
  {
    setSelectedProvider(provider); // Para editar el proveedor existente
  };

  //-----------------------------------------------------------

  const handleFormClose = () => 
  {
    setSelectedProvider(null); // Cerrar el formulario
    fetchProviders(); // Refrescar la lista de proveedores después de guardar o eliminar
  };

  //-----------------------------------------------------------

  return (
    <div className="eventos-container">
      {selectedProvider === null ? (
        <div>
          <div>
            <table>
              <tbody>
                <tr>
                  <td>
                    <button
                      className="create-event-button"
                      onClick={handleCreateClick}>
                      <i className="fas fa-plus-circle"></i> Crear PROVEEDOR
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          {loading && <p>Buscando proveedores...</p>}
          {error && <p className="error-message">{error}</p>}
          {!loading && !error && providers.length === 0 && <p>No hay proveedores para mostrar.</p>}
          {!loading && !error && providers.length > 0 && (
            <table className="eventos-table">
              <tbody>
                {providers.map(provider => (
                  <tr key={provider.id}>
                    <td className="evento-name">{provider.name}</td>
                    <td className="api-key">{provider.api_key}</td>
                    <td className="evento-actions">
                      <button className="action-button edit-button" onClick={() => handleEditClick(provider)}><i className="fas fa-pencil"></i>Editar</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      ) : (
        <div className="form-overlay">
          <Proveedor
            provider={selectedProvider} 
            onSave={handleFormClose}
            onCancel={handleFormClose}
            onDelete={(providerId) => {
              setProviders(providers.filter(provider => provider.id !== providerId));
              handleFormClose();
            }}
          />
        </div>
      )}
    </div>
  );
};  

export default Proveedores;
